import React from "react";
import ForgetPasswordTemplate from "templates/auth/forgetPassword";
export default function ForgetPasswordPage() {
  return <ForgetPasswordTemplate />;
}
